import logdna from '@logdna/browser';
const LOGDNA_INGESTION_KEY = process.env.REACT_APP_LOGDNA_INGESTION_KEY || '6bff8a47e9f6606aaf1855443ea9dc29';
class LogDNA {
    constructor(addContext) {
        this.email = localStorage.getItem('email') ? `email: ${localStorage.getItem('email')}, ` : '';
        this.code = localStorage.getItem('code') ? `code: ${localStorage.getItem('code')}, ` : '';
        this.base = `${this.email}${this.code}`;
        logdna.init(LOGDNA_INGESTION_KEY, {
            app: `sumadi-exams-students-${process.env.REACT_APP_LOGDNA_ENVIRONMENT || 'test'}`,
            env: process.env.REACT_APP_LOGDNA_ENVIRONMENT || 'test',
            console: false,
            globalErrorHandlers: false,
            tags: ['sumadi-exams-students'],
        });
        logdna.addContext(Object.assign({ REACT_APP_SUMADI_EXAMS_API: process.env.REACT_APP_SUMADI_EXAMS_API || '', REACT_APP_SUMADI_EXAMS_AUTH_SERVICES_URL: process.env.REACT_APP_SUMADI_EXAMS_AUTH_SERVICES_URL || '', REACT_APP_SUMADI_APP_SERVER_URL_V2: process.env.REACT_APP_SUMADI_APP_SERVER_URL_V2 || '' }, addContext));
    }
    log(message, context) {
        logdna.log(`${this.base} ${JSON.stringify(message)}`, context);
    }
    error(message, context) {
        logdna.error(`${this.base} ${JSON.stringify(message)}`, context);
    }
    debug(message, context) {
        logdna.debug(`${this.base} ${JSON.stringify(message)}`, context);
    }
    info(message, context) {
        logdna.info(`${this.base} ${JSON.stringify(message)}`, context);
    }
    warn(message, context) {
        logdna.warn(`${this.base} ${JSON.stringify(message)}`, context);
    }
}
export default LogDNA;
